import VueAuthorize from './authorize.js'
import IsAuthorizedInvisibleDirective from './invisible-directive.js'
import IsAuthorizedDisableDirective from './disable-directive.js'
import IsAuthorizedComponent from './component.js'
import Acl from './acl.js'
/**
 * VueAuthorize plugin
 * @param {Object} Vue
 */
function plugin (Vue, options) {
  if (plugin.installed) {
    return
  }

  options = Acl

  Vue.directive('isVisibleAuthorized', IsAuthorizedInvisibleDirective)
  Vue.directive('isEnableAuthorized', IsAuthorizedDisableDirective)
  Vue.component('isAuthorized', IsAuthorizedComponent)

  let vueAuthorizeInstance = null
  Object.defineProperties(Vue.prototype, {
    $authorize: {
      get () {
        if (!vueAuthorizeInstance) {
          vueAuthorizeInstance = new VueAuthorize(this.$auth, options)
        }
        return vueAuthorizeInstance
      }
    }
  })
}

export default plugin
export { VueAuthorize }



// WEBPACK FOOTER //
// ./src/_fdp/core/directive/acl/index.js